import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'
import { hairlineBorder } from '../../../lib/hairline'

export type ProsConsTone = 'cons' | 'pros'

const toneColor = (tone: ProsConsTone) => (tone === 'cons' ? LANDING_COLORS.negative : LANDING_COLORS.positive)

export const ProsConsContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding: 60px 0 0;
  background-color: ${COLORS.bgWhite};
`

export const ProsConsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`

export const GroupHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`

export const GroupHeaderIcon = styled.img`
  width: 22px;
  height: 22px;
`

export const GroupHeaderText = styled('p', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: ProsConsTone }>`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.33px;
  color: ${({ tone }) => toneColor(tone)};
`

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 30px;
`

export const CardContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: ProsConsTone }>`
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 20px 12px 20px 20px;
  border-radius: 4px;
  background-color: ${({ tone }) => (tone === 'cons' ? LANDING_COLORS.consCardBg : LANDING_COLORS.prosCardBg)};
  /* 0.5px 하단 변이 일부 webview 에서 사라지는 문제 — 레티나 헤어라인으로 대응 */
  ${({ tone }) => hairlineBorder(tone === 'cons' ? LANDING_COLORS.consCardBorder : LANDING_COLORS.prosCardBorder)}
`

export const CardIcon = styled.img`
  flex-shrink: 0;
  width: 90px;
  height: 90px;
  border-radius: 4px;
  object-fit: cover;
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const CardTag = styled('p', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: ProsConsTone }>`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${({ tone }) => toneColor(tone)};
`

export const CardDesc = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const CardDescLine = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${COLORS.textTertiary};
`
